import Cookies from 'js-cookie'
const LowcodeTokenKey = 'lowcode_token'
const TokenKey = 'base_token'
const sysKey = 'sysCode'
const userIdKey = 'userId'
const userNameKey = 'userName'
const loginNameKey = 'loginName'
const storeKey = 'store'

export function setUserInfo(user) {
    setUserId(user.uuid);
    setUserName(user.realName);
    setLoginName(user.loginName);
}

export function setCookies(key,value) {
    Cookies.set(key, value)
}

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
   localStorage.setItem(TokenKey,token);
   Cookies.set(LowcodeTokenKey, token)
}

export function removeToken() {
    localStorage.removeItem(TokenKey);
}

export function getSysId() {
    return localStorage.getItem(sysKey)
}

export function setSysId(sysId) {
    localStorage.setItem(sysKey,sysId);
}

export function getUserId() {
    return localStorage.getItem(userIdKey)
}

export function setUserId(userId) {
    localStorage.setItem(userIdKey,userId)
}

export function getUserName() {
    return localStorage.getItem(userNameKey)
}

export function setUserName(userName) {
    localStorage.setItem(userNameKey,userName)
}

export function removeUserId() {
    localStorage.removeItem(userIdKey)
}

export function removeUserName() {
    localStorage.removeItem(userNameKey)
}

export function getLoginName() {
    return localStorage.getItem(loginNameKey)
}

export function setLoginName(loginName) {
    localStorage.setItem(loginNameKey,loginName)
}

export function getStore() {
    return localStorage.getItem(storeKey)
}

export function setStore(store) {
    localStorage.setItem(storeKey,store)
}

export function clearLoginInfo() {
    localStorage.removeItem(userIdKey)
    localStorage.removeItem(userNameKey)
    localStorage.removeItem(loginNameKey)
    localStorage.removeItem(TokenKey)
    Cookies.remove(LowcodeTokenKey)
    Cookies.remove('cssSessionId')
}
